import { createSlice } from "@reduxjs/toolkit";
import axios from "src/utils/axios";

const initialState = {
  isLoading: false,
  error: false,
  discounts: [],
  discount: null,
  selectedDiscount: null,
};

// ----------------------------------------------------------------------

const slice = createSlice({
  name: "discounts",
  initialState,
  reducers: {
    // LOADING
    startLoading(state) {
      state.isLoading = true;
    },
    stopLoading(state) {
      state.isLoading = false;
    },

    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },

    createDiscountsuccess(state, action) {
      state.isLoading = false;
      state.discounts = [...state.discounts, action.payload];
    },

    getDiscountsSuccess(state, action) {
      state.isLoading = false;
      state.discounts = action.payload;
    },

    getDiscountSuccess(state, action) {
      state.isLoading = false;
      state.discount = state.discounts.find(
        (u) => u.id === Number(action.payload)
      );
    },

    deleteDiscountSuccess(state, action) {
      state.discounts = state.discounts.map((u) => {
        if (u.id === Number(action.payload)) return { ...u, isActive: false };
        return u;
      });
    },

    updateDiscountSuccess(state, action) {
      state.discounts = state.discounts.map((u) => {
        if (u.id === Number(action.payload.id)) return action.payload;
        return u;
      });
    },

    setSelectedDiscount(state, action) {
      state.selectedDiscount = action.payload;
    },

    cleanSelectedDiscount(state, action) {
      state.discount = null;
    },

    cleanSelectedApplyDiscount(state, action) {
      state.selectedDiscount = null;
    },

    // REDUCERS...
  },
});

// ----------------------------------------------------------------------

// Reducer
export default slice.reducer;

// Actions
export const {
  createDiscountsuccess,
  getDiscountSuccess,
  getDiscountsSuccess,
  deleteDiscountSuccess,
  updateDiscountSuccess,
  cleanSelectedDiscount,
  setSelectedDiscount,
  cleanSelectedApplyDiscount,
} = slice.actions;

// ----------------------------------------------------------------------

export function CreateDiscount(create) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());

    try {
      var response = await axios.post(`discount/create`, {
        ...create,
      });
      dispatch(slice.actions.createDiscountsuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function GetDiscounts() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());

    try {
      const userId = window.localStorage.getItem("userId");
      var response = await axios.get(`discount/read`);
      dispatch(slice.actions.getDiscountsSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function DeleteDiscount(discountId) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());

    try {
      dispatch(slice.actions.deleteDiscountSuccess(discountId));
      await axios.delete(`discount/delete/${discountId}`);
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function UpdateDiscount(update) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());

    try {
      var res = await axios.put(`discount/update`, {
        ...update,
      });

      dispatch(slice.actions.updateDiscountSuccess(res.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------
